export default __webpack_public_path__ + "static/media/empty.7b7ce86c.svg";